import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function usePayors() {
  return useSuspenseQuery({
    ...apiClient.listPayorsPayorsGetOptions(),
  })
}
